
import React, { useEffect } from "react";
import { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, TextField } from "@mui/material";

export const EditPersonDialog = ({ open, handleCancel, handleSubmit, roleOptions, existingRoles, userName }) => {
    const [selectedRoles, setSelectedRoles] = React.useState<string[]>(existingRoles)
    const closeAndClear = () => {
        setSelectedRoles([])
        handleCancel()
    }

    const handleRolesChange = (_event, newValue) => {
        setSelectedRoles(newValue)
    }

    useEffect(() => {
        setSelectedRoles(existingRoles)
    }, [existingRoles])

    return (
        <Dialog
            open={open}
            onClose={closeAndClear}
            slotProps={{
                paper: {
                    component: 'form',
                    onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
                        event.preventDefault();
                        handleSubmit(userName, selectedRoles);
                        closeAndClear();
                    },
                },
            }}
            fullWidth={true}
            maxWidth={"sm"}
        >
            <DialogTitle>Edit</DialogTitle>
            <DialogContent>
                <FormControl fullWidth margin="normal">
                    <TextField
                        disabled
                        margin="dense"
                        id="userName"
                        name="userName"
                        label="Username"
                        type="text"
                        fullWidth
                        variant="standard"
                        value={userName}
                    />
                </FormControl>
                <FormControl fullWidth margin="normal">
                     <Autocomplete
                        id="edit-roles-autocomplete"
                        multiple
                        options={roleOptions}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Roles"
                                name="roles"
                            />
                        )}
                        value={selectedRoles}
                        onChange={handleRolesChange}
                    />
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button onClick={closeAndClear}>Cancel</Button>
                <Button type="submit">Submit</Button>
            </DialogActions>
        </Dialog>
    )
}
